import { Component, Input } from '@angular/core';

@Component({
	selector: 'cv-cvds-field-array',
	templateUrl: './cvds-field-array.component.html',
	styleUrls: ['../../cvds-structures.component.scss']
})
export class CvdsFieldArrayComponent {
	@Input() items: any;
	@Input() title: string;
	@Input() fields: any;
}
